const baseUrl = process.env.VUE_APP_API_BASE_URL ?? "";
const admin = "/admin";
const v1 = "";

export const api = {
  dynamicEndpoint: baseUrl + admin + v1 + "/",

  // login
  login: baseUrl + admin + v1 + "/auth/login",
  profile: baseUrl + admin + v1 + "/auth/profile",
  logout: baseUrl + admin + v1 + "/auth/logout",
  refreshToken: baseUrl + admin + v1 + "/auth/refresh-token",

  // localize
  listLocalizations:
    baseUrl + admin + v1 + "/language-translation/setting/list",
  listLanguage: baseUrl + admin + v1 + "/language-translation/list",

  // master data
  listMasterData: baseUrl + admin + v1 + "/master-data/list",

  // user
  listUsers: baseUrl + admin + v1 + "/user/list",
  createUser: baseUrl + admin + v1 + "/user/create",
  updateUser: baseUrl + admin + v1 + "/user/update",
  deleteUser: baseUrl + admin + v1 + "/user/delete",

  // role
  listRoles: baseUrl + admin + v1 + "/role/list",
  createRole: baseUrl + admin + v1 + "/role/create",
  updateRole: baseUrl + admin + v1 + "/role/update",
  deleteRole: baseUrl + admin + v1 + "/role/delete",

  // permission
  listPermissions: baseUrl + admin + v1 + "/permission/list",
  createPermission: baseUrl + admin + v1 + "/permission/create",

  // Upload
  uploadMedia: baseUrl + admin + v1 + "/upload/media",
  listMedia: baseUrl + admin + v1 + "/media/list",
  detailMedia: baseUrl + admin + v1 + "/media/detail",
  folderMedia: baseUrl + admin + v1 + "/media/folder/list",
};
